module.exports = __webpack_public_path__ + "img/logo.90bb7c71.png";